export class patientBasicSearchResult {

    Id: number;
    PatientCode: string;
    FirstName: string;
    FatherName: string;
    MidName: string;
    LastName: string;
    OtherFirstName: string;
    OtherFatherName: string;
    OtherMidName: string;
    OtherLastName: string;
    BirthDate: Date;
    RoomSpecialityId: number;
   
    constructor() { }
}
